module.exports = __webpack_public_path__ + "img/pepsico.de6f150c.png";